import colors from '@/theme/colors';

export const CREATOR_APPLICATION_BACKGROUND = `linear-gradient(180deg, ${colors.primary[500]} 0%, #DC733E 100%)`;
export const CREATOR_APPLICATION_BACKGROUND_OPACITY = 0.78;
